import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import currentVersion from '../version.json'

const CHECK_INTERVAL_MS = 5 * 60 * 1000 // 5 minutes

export function useVersionCheck() {
  const location = useLocation()
  const lastChecked = useRef<number>(0)

  useEffect(() => {
    const now = Date.now()
    if (now - lastChecked.current < CHECK_INTERVAL_MS) return
    lastChecked.current = now

    fetch('/version.json?t=' + now, { cache: 'no-store' })
      .then(r => r.json())
      .then((data: { commitSha: string }) => {
        if (data.commitSha && data.commitSha !== currentVersion.commitSha) {
          window.location.reload()
        }
      })
      .catch(() => {
        // ignore — network errors shouldn't interrupt the user
      })
  }, [location.pathname])
}
